<!-- display-desktop-02 preview — publisher site (desktop), hotel banner above the article -->
<app-desktop-frame>
  <div class="gs-page">
    <!-- START: Site header -->
    <i class="bi bi-person-circle gs-account"></i>
    <div class="gs-site-name">website</div>
    <div class="gs-nav d-flex flex-row align-items-center">
      <span *ngFor="let _ of navItems" class="gs-skel gs-skel-nav"></span>
      <span class="gs-nav-icons d-flex flex-row align-items-center">
        <i class="bi bi-search"></i>
        <i class="bi bi-arrow-90deg-right"></i>
        <i class="bi bi-share"></i>
        <i class="bi bi-envelope"></i>
        <i class="bi bi-rss"></i>
      </span>
    </div>
    <!-- END: Site header -->

    <!-- START: Real ad -->
    <a class="gs-banner d-flex flex-row" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <span class="gs-banner-image">
        <img [src]="hotel.image" alt="" />
      </span>
      <span class="gs-banner-body d-flex flex-column">
        <span class="gs-banner-title">{{ hotel.title }}</span>
        <span class="gs-banner-subtitle">{{ hotel.subtitle }}</span>
        <span class="gs-banner-meta d-flex flex-row align-items-center">
          <span class="gs-badge">Oglas</span>
          <span class="gs-brand-name">Valamar</span>
        </span>
        <span class="gs-banner-cta">{{ ctaText }}</span>
      </span>
      <i class="bi bi-info-circle gs-info"></i>
    </a>
    <!-- END: Real ad -->

    <!-- Article, context only -->
    <div class="gs-article" aria-hidden="true">
      <span *ngFor="let w of articleLines" class="gs-skel gs-skel-line" [style.width.%]="w"></span>
      <span class="gs-skel gs-skel-media"></span>
    </div>
  </div>
</app-desktop-frame>
